module.exports = __webpack_public_path__ + "img/logo-dark.520fd2fe.png";